export default __webpack_public_path__ + "static/nici-c3abd68b6805cebd6f32f63c74b42dfa.svg";